<template>
<div>
<SidebarMenu
      :menu="menu"
      :collapsed="isSideBarCollapsed"
      :theme="selectedTheme"
      :show-one-child="false"
      @collapse="onCollapse"
></SidebarMenu>
</div>
</template>

<script>
import SidebarMenu from "@/components/menu/SidebarMenu.vue";
import MenuService from "@/services/menu.service";
import AuthService from "@/services/auth.service";
import HttpService from "@/services/http.service";
import AdminPermissionsService from "@/services/admin-permissions.service";

export default {
  name: "SideBar",

  components: {
    SidebarMenu,
  },

  props: {
    isSideBarCollapsed: Boolean,
  },

  data() {
    return {
      menu: [],
      collapsed: false,
      themes: ["", "lloyds-theme"],
      selectedTheme: "lloyds-theme",
    };
  },

  watch: {
    async $route() {
      const urlPathSplit = this.$route.path.split("/");
      const urlPath = urlPathSplit[urlPathSplit.length - 1];
      if (urlPath && (urlPath === "reports" || urlPath === "report")) {
        this.buildMenu(); // remains unchanged
        this.loadBadges(); // ensure badges reload on report page changes
      }
    },
  },

  async created() {
    await this.buildMenu();  // show menu instantly
    this.loadBadges();       // load badges asynchronously
  },

  methods: {
    async buildMenu() {
      const as = new AuthService();
      let { is_ih_admin, is_da_admin, with_pdf_reports } = as.decodeHeader();

      // Build menu with default badges = 0
      this.menu = await MenuService.buildMenu(
        is_ih_admin,
        is_da_admin,
        with_pdf_reports,
        0,
        0,
        0
      );

      this.$emit("eventCollapseSideBar", this.collapsed);
    },

    async loadBadges() {
      const as = new AuthService();
      const { is_ih_admin, is_da_admin } = as.decodeHeader();
      const aps = new AdminPermissionsService();

      try {
        const res = await HttpService.get("/getBadges");

        let ihBadge = 0;
        let daBadge = 0;
        let repBadge = +res.reportsBadge;

        if (is_ih_admin && aps.canWrite("devolved_admin_requests")) {
          ihBadge = +res.ihBadge;
        }

        if (is_da_admin) {
          daBadge = +res.daBadge;
        }

        this.updateBadge("Admin", ihBadge);
        this.updateBadge("Administration", daBadge);
        this.updateBadge("Reports", repBadge);

      } catch (error) {
        console.error("Error loading badges:", error);
      }
    },

    updateBadge(title, value) {
      const item = this.menu.find(m => m.title === title);
      if (item) {
        if (this.$set) {
          this.$set(item, "badge", value);
        } else {
          item.badge = value;
        }
      }
    },

    onCollapse(collapsed) {
      this.collapsed = collapsed;
      this.$emit("eventCollapseSideBar", this.collapsed);
    },
  },
};
</script>